import { Skeleton } from "@/components/states";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { formatPercent } from "@/lib/format";

/**
 * Stat tile for a single 0..1 ratio: big percent plus a linear meter.
 * (The Looker originals drew these as gauges; a meter is the same ratio
 * without the arc.) An undefined value renders a loading shimmer; null
 * renders an em dash (ratio undefined, e.g. no category units).
 */
export function MeterCard({
  label,
  value,
}: {
  label: string;
  value?: number | null;
}) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="text-sm text-muted-foreground">{label}</div>
      </CardHeader>
      <CardContent>
        {value === undefined ? (
          <Skeleton className="h-9 w-20" />
        ) : value === null ? (
          <div className="text-3xl font-semibold text-muted-foreground">—</div>
        ) : (
          <>
            <div className="text-3xl font-semibold">
              {formatPercent(Math.min(1, value), 2)}
            </div>
            <div
              className="mt-2 h-1.5 w-full overflow-hidden rounded-full"
              style={{ background: "var(--viz-meter-track)" }}
              role="meter"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={Math.round(Math.min(1, value) * 100)}
              aria-label={label}
            >
              <div
                className="h-full rounded-full"
                style={{
                  width: `${Math.min(1, value) * 100}%`,
                  background: "var(--viz-series-1)",
                }}
              />
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
